

export function is_on_wikisim(): boolean
{
    return document.URL.includes("https://wikisim-server.wikisim.deno.net")
}
